<template>
  <admin title="Dashboard " menu="Dashboard">
    <div class="col-lg-12 col-xs-12">
      <div class="row mb-3">
        <div class="col-lg-4 col-xs-12">
          <div class="bg_black card">
            <div class="card-body">
              <p class="f30">
                {{
                  (balance.waiting_funds.amount / 100)
                    | currency("R$ ", 2, {
                      decimalSeparator: ",",
                      thousandsSeparator: ".",
                    })
                }}
              </p>
              A compensar
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-xs-12">
          <div class="bg_black card">
            <div class="card-body">
              <p class="f30">
                {{
                  (balance.available.amount / 100)
                    | currency("R$ ", 2, {
                      decimalSeparator: ",",
                      thousandsSeparator: ".",
                    })
                }}
              </p>
              Disponivel
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-xs-12">
          <div class="bg_black card">
            <div class="card-body">
              <p class="f30">
                {{
                  (balance.transferred.amount / 100)
                    | currency("R$ ", 2, {
                      decimalSeparator: ",",
                      thousandsSeparator: ".",
                    })
                }}
              </p>
              Transferido
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-12 col-xs-12">
          <div class="bg_black card">
            <div class="card-body">
              <h2>Licenças por dia</h2>
              <line-chart :chart-data="datacollection"></line-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-6 col-xs-12">
          <div class="bg_black card">
            <div class="card-body">
              <h3>Licenças por semana</h3>
              <line-chart :chart-data="datacollection_week"></line-chart>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xs-12">
          <div class="bg_black card">
            <div class="card-body">
              <h3>Licenças por mês</h3>
              <line-chart :chart-data="datacollection_months"></line-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <h3>Últimos acessos</h3>
          <table class="table_jovool table_jovool_dark mt-3">
            <thead class="headerTable">
              <tr class="text-center">
                <td class="center">Nome</td>
                <td class="center">Data</td>
                <td class="center">Empresa</td>
              </tr>
            </thead>
            <tbody class="position-relative">
              <tr v-for="user in users" :key="user.id">
                <td class="center">
                  <div>{{ user.name }}</div>
                </td>
                <td class="center">
                  <div>
                    {{ user.last_sign_in_at | moment("DD/MM/YYYY LT") }}
                  </div>
                </td>
                <td class="center">
                  <div>{{ user.business_name }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </admin>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import LineChart from "components/LineChart.js";
import Vue2Filters from "vue2-filters";
import { mask } from "vue-the-mask";
export default {
  components: { LineChart },
  props: ["balance", "recruiters_days", "recruiters_week", "recruiters_months"],
  directives: { mask },
  mixins: [Vue2Filters.mixin],
  data: () => ({
    users: "",
    recruiters_days_data: [],
    recruiters_week_data: [],
    recruiters_months_data: [],
    datacollection: {},
    datacollection_week: {},
    datacollection_months: {},
  }),
  mounted() {
    this.lastUsers();
    this.recruiters_days_data[0] = [];
    this.recruiters_days_data[1] = [];
    for (let index in this.recruiters_days) {
      this.recruiters_days_data[0].push(this.formattedMonthDay(index));
      this.recruiters_days_data[1].push(this.recruiters_days[index]);
    }

    this.recruiters_week_data[0] = [];
    this.recruiters_week_data[1] = [];
    for (let index in this.recruiters_week) {
      this.recruiters_week_data[0].push(this.formattedMonthDay(index));
      this.recruiters_week_data[1].push(this.recruiters_week[index]);
    }

    this.recruiters_months_data[0] = [];
    this.recruiters_months_data[1] = [];
    for (let index in this.recruiters_months) {
      this.recruiters_months_data[0].push(this.formattedMonthDay(index));
      this.recruiters_months_data[1].push(this.recruiters_months[index]);
    }
    this.fillData();
  },
  methods: {
    formattedMonthDay(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM");
    },
    fillData() {
      this.datacollection = {
        labels: this.recruiters_days_data[0],
        showLine: true,
        backgroundColor: "#000",
        datasets: [
          {
            label: "Recrutadores por dia",
            borderColor: "#9570fd",
            backgroundColor: "#000",
            data: this.recruiters_days_data[1],
            fill: false,
          },
        ],
      };

      this.datacollection_week = {
        labels: this.recruiters_week_data[0],
        showLine: true,
        backgroundColor: "#000",
        datasets: [
          {
            label: "Recrutadores por semana",
            borderColor: "#9570fd",
            backgroundColor: "#000",
            data: this.recruiters_week_data[1],
            fill: false,
          },
        ],
      };

      this.datacollection_months = {
        labels: this.recruiters_months_data[0],
        showLine: true,
        backgroundColor: "#000",
        datasets: [
          {
            label: "Recrutadores por mês",
            borderColor: "#9570fd",
            backgroundColor: "#000",
            data: this.recruiters_months_data[1],
            fill: false,
          },
        ],
      };
    },
    lastUsers() {
      axios.get("/admins/dashboard/search").then((response) => {
        this.users = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>